<template>
    <div :class="classVariantBox" class="variant">
        <div class="row col-12 mb-2 variant--head" @click="toggleVisibility">
            <div class="variant__arrow"></div>
            <div class="col-8">
                <h3>
                    {{ name }}
                    <em v-if="validTill" class="mt-2">{{ $t('service.validTo') }} {{ validTill }}.</em>
                </h3>
            </div>
        </div>

        <div v-show="isVisible" class="col variant--content">
            <template v-if="includedInPrice">
                <h4>{{ $t('service.inPrice') }}</h4>
                <div v-html="includedInPrice"></div>
            </template>
            <template v-if="howToUse">
                <h4>{{ $t('service.howUse') }}</h4>
                <div v-html="howToUse"></div>
            </template>
        </div>

        <div v-show="isVisible && isPublished" class="col variant--footer">
            <!--      <p>Můžete zakoupit max. 1 voucher na osobu.</p>-->
            <div class="col-md-12 d-flex justify-content-end">
                <p>
                    <strong class="text-primary">{{ $formatCurrency(price) }}</strong>
                </p>
                <ElementsButtonAddBasket
                    class="float-right ms-2"
                    :product-id="product.id"
                    :product-price="product.price"
                    :is-preorder="product.isPreorder"
                    :max-amount-per-order="product.attributes.maxAmountPerOrder"
                    :has-substitution-modal="product.substitutions?.isModal || false"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        productId: {
            type: Number,
            required: true,
        },
        product: {
            type: Object,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        validTill: {
            type: String,
            required: true,
        },
        price: {
            type: Number,
            required: true,
        },
        howToUse: {
            type: String,
            default: '',
        },
        includedInPrice: {
            type: String,
            default: '',
        },
        isOpen: {
            type: Boolean,
            default: true,
        },
        isPublished: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isVisible: false,
            classVariantBox: 'closeVariant',
        }
    },

    mounted() {
        if (this.isOpen) {
            this.toggleVisibility()
        }
    },

    methods: {
        toggleVisibility() {
            this.isVisible = !this.isVisible
            this.classVariantBox = this.isVisible ? 'openVariant' : 'closeVariant'
        },
    },
}
</script>
<style lang="scss" scoped>
.variant {
    background: $color-grey;
    margin-bottom: 15px;
    padding: 20px 15px 1px 15px;
    position: relative;
    border-radius: 5px;

    &--head {
        cursor: pointer;

        p {
            display: inline-block;
            padding: 7px 5px;
            font-size: 18px;

            s {
                font-size: 14px;
            }
        }
    }

    h4 {
        font-size: 18px;
    }

    ul {
        li {
            font-size: 14px;
            line-height: 30px;
            list-style-type: none;

            &::before {
                content: '';
                background: $color-cta;
                width: 5px;
                height: 5px;
                display: inline-block;
                border-radius: 25px;
                margin-right: 10px;
                position: relative;
                top: -3px;
            }
        }
    }

    h2 {
        margin-bottom: 20px;
    }

    h3 {
        em {
            display: block;
            color: $color-grey-extra-dark;
            font-size: 14px;
            font-style: normal;
            letter-spacing: normal;
            line-height: 19px;
            font-weight: normal;
        }
    }

    &__arrow {
        content: '';
        display: block;
        width: 14px;
        height: 8px;
        position: absolute;
        background: url('#{$path-icon}arrow-top.svg') no-repeat;
        transform: rotate(180deg);
        right: 3%;
        margin-top: 7px;
    }

    &--content {
        border-top: 1px solid #94aab3;
        padding-top: 20px;
    }

    &--footer {
        text-align: right;
        margin-top: 30px;
        margin-bottom: 1em;

        p {
            display: inline-block;
            padding: 7px 21px;
            font-size: 18px;

            s {
                font-size: 14px;
            }
        }
    }

    &.openVariant {
        .variant__arrow {
            transform: rotate(0deg);
        }
    }
}
</style>
<style lang="scss" scoped>
.variant__tab.card {
    background: transparent;
    border: none;

    .nav-tabs,
    .card-header {
        background: #fff;
        padding: 0;
        border: none;
        font-weight: 500;
    }

    .card-header-tabs {
        background: rgb(0 0 0 / 0%);
        margin: 0;
    }

    .nav-link {
        padding: 10px 30px;
        position: relative;

        &.active {
            &::after {
                content: '';
                display: block;
                width: 0;
                height: 0;
                border-left: 8px solid rgb(0 0 0 / 0%);
                border-right: 8px solid rgb(0 0 0 / 0%);
                border-bottom: 15px solid rgb(255 255 255);
                position: absolute;
                bottom: -25px;
                margin-left: 2px;
                z-index: 10;
                left: 45%;
            }

            &::before {
                content: '';
                display: block;
                width: 0;
                height: 0;
                border-left: 10px solid rgb(0 0 0 / 0%);
                border-right: 10px solid rgb(0 0 0 / 0%);
                border-bottom: 17px solid rgb(225 225 225);
                position: absolute;
                bottom: -25px;
                z-index: 10;
                left: 45%;
            }
        }
    }

    .nav-tabs .nav-link.active,
    .nav-tabs .nav-link,
    .nav-tabs .nav-item.show .nav-link {
        background: transparent;
        text-align: center;
        border: none;
    }

    .card-body {
        background: rgb(255 255 255);
        margin-top: 25px;
        box-shadow: 0 2px 4px rgb(0 0 0 / 20%);
        border: 1px solid rgb(225 225 225);
        border-radius: 5px;
        position: relative;

        p {
            font-size: 14px;
        }
    }
}
</style>
